import React from 'react';

function PrivacyPolicy() {
  return (
    <div className="container">
      <div className="card">
        <h2 style={{ marginBottom: '1.5rem' }}>Privacy Policy</h2>
        <p style={{ marginBottom: '1rem', color: '#757575' }}>Last Updated: June 2026</p>
        
        <div style={{ lineHeight: '1.8' }}>
          <p style={{ marginBottom: '1rem' }}>
            Welcome to <strong>La Provence Bakery</strong>. We highly respect your privacy and are committed to protecting the personal information of our website visitors.
          </p>

          <h3 style={{ margin: '1.5rem 0 0.5rem' }}>1. Information We Collect</h3>
          <p style={{ marginBottom: '1rem' }}>
            We only collect information that you voluntarily provide through our contact form, such as your name, email address, and the contents of your message.
          </p>

          <h3 style={{ margin: '1.5rem 0 0.5rem' }}>2. Use of Information</h3>
          <p style={{ marginBottom: '1rem' }}>
            The information you provide will only be used to respond to your inquiries, process catering orders, and improve our bakery services. We will never sell or rent your data to third parties.
          </p>

          <h3 style={{ margin: '1.5rem 0 0.5rem' }}>3. Data Security</h3>
          <p style={{ marginBottom: '1rem' }}>
            We take reasonable measures to protect your personal data from unauthorized access, use, or disclosure.
          </p>

          <h3 style={{ margin: '1.5rem 0 0.5rem' }}>4. Contact Us</h3>
          <p>
            If you have any questions regarding this Privacy Policy, please visit our <a href="/contact" style={{ color: '#d84315' }}>Contact Us</a> page.
          </p>
        </div>
      </div>
    </div>
  );
}

export default PrivacyPolicy;